import { useState } from 'react'
import type { FormEvent } from 'react'
import { useAuth } from '@shop/api-client'
import { BRAND } from '@shop/shared'
import { Banner, Button, ErrorBanner, Field, TextInput } from '@shop/ui'

/**
 * بابُ الدخول.
 *
 * <b>ولا رسالةَ هنا تُصاغ في الواجهة</b>: الخادمُ يردّ «اسمُ المستخدم أو كلمةُ
 * المرور غير صحيحة» برمزٍ واحدٍ للحالتين عمدًا، حتى لا يصير البابُ أداةً لعدّ
 * موظّفينا. ولو أضافت الواجهةُ «هذا المستخدم غير موجود» من عندها لَنقضت ذلك كلَّه.
 */
export default function Login() {
  const { login, endedByIdle } = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<unknown>(null)
  const [busy, setBusy] = useState(false)

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    setBusy(true)
    setError(null)

    try {
      await login(username.trim(), password)
    } catch (failure) {
      setError(failure)

      // الكلمةُ تُمحى من الحالة عند الإخفاق: شاشةٌ تُترك مفتوحةً على الطاولة
      // بكلمةٍ مكتوبةٍ في حقلٍ هي كلمةٌ مكشوفة.
      setPassword('')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-10">
      <form
        className="w-full max-w-sm space-y-4 rounded-lg border border-line bg-surface-raised p-6"
        onSubmit={submit}
      >
        <div className="text-center">
          <h1 className="text-xl font-semibold">{BRAND.nameAr}</h1>
          <p className="mt-1 text-xs tracking-wide text-ink-soft" dir="ltr">
            {BRAND.nameEn}
          </p>
        </div>

        <Field label="اسم المستخدم">
          <TextInput
            value={username}
            onChange={setUsername}
            name="username"
            autoComplete="username"
            dir="ltr"
            autoFocus
            disabled={busy}
          />
        </Field>

        <Field label="كلمة المرور">
          <TextInput
            value={password}
            onChange={setPassword}
            type="password"
            name="password"
            autoComplete="current-password"
            dir="ltr"
            disabled={busy}
          />
        </Field>

        {endedByIdle && !error && (
          <Banner tone="info">خرجتَ تلقائيًّا بعد ساعتين بلا استخدام — ادخل من جديد.</Banner>
        )}

        <ErrorBanner error={error} />

        <Button type="submit" tone="primary" wide disabled={busy || !username.trim() || !password}>
          {busy ? 'يجري الدخول…' : 'دخول'}
        </Button>
      </form>
    </div>
  )
}
